import styled from 'styled-components';
import Icon from '@nubank/nuds-web/components/Icon/Icon';

export const StyledIcon = styled(Icon)`
  flex-shrink: 0;
  margin-left: 1rem;
  margin-top: 0.25rem;
`;

StyledIcon.displayName = 'StyledIcon';
